import Vue from 'vue';
import VueRouter from 'vue-router';
import { getURLSearchParams } from '@/utils/utils';
Vue.use(VueRouter);

const routes = [
  {
    path: '/spaceReservation/spaceList',
    name: 'spaceReservationSpaceList',
    component: () => import('@/sub-app/spaceReservation/pages/spaceList.vue'),
    meta: {
      title: '空间预定',
      keepAlive: false,
    },
  },
  {
    path: '/spaceReservation/spaceDetails',
    name: 'spaceReservationSpaceDetails',
    component: () => import('@/sub-app/spaceReservation/pages/components/spaceDetails.vue'),
    meta: {
      title: '空间预定详情',
      keepAlive: false,
    },
  },
  // 添加时间选择
  {
    path: '/spaceReservation/spaceBalance',
    name: 'spaceReservationSpaceBalance',
    component: () => import('@/sub-app/spaceReservation/pages/components/spaceBalance.vue'),
    meta: {
      title: '空间预定',
      keepAlive: false,
    },
  },
  // 确认订单页面
  {
    path: '/spaceReservation/spaceConfirmOrder',
    name: 'spaceReservationSpaceConfirmOrder',
    component: () => import('@/sub-app/spaceReservation/pages/components/spaceConfirmOrder.vue'),
    meta: {
      title: '确认订单',
      keepAlive: false,
    },
  },
  // 我的页面
  {
    path: '/spaceReservation/myOrderList',
    name: 'spaceReservationMyOrderList',
    component: () => import('@/sub-app/spaceReservation/pages/myOrderList.vue'),
    meta: {
      title: '我的订单',
      keepAlive: false,
    },
  },
  // 订单详情页面
  {
    path: '/spaceReservation/spaceOrderDetails',
    name: 'spaceReservationSpaceOrderDetails',
    component: () => import('@/sub-app/spaceReservation/pages/components/spaceOrderDetails.vue'),
    meta: {
      title: '订单详情',
      keepAlive: false,
    },
  },
  // 空间预定管理页面
  {
    path: '/spaceReservation/spaceReservatManage',
    name: 'spaceReservationSpaceReservatManage',
    component: () => import('@/sub-app/spaceReservation/pages/spaceReservatManage.vue'),
    meta: {
      title: '空间预定管理',
      keepAlive: false,
    },
  },
  // 审核订单页面
  {
    path: '/spaceReservation/reviewOrderPage',
    name: 'spaceReservationreviewOrderPage',
    component: () => import('@/sub-app/spaceReservation/pages/components/reviewOrder.vue'),
    meta: {
      title: '审核订单',
      keepAlive: false,
    },
  },
  // 审核订单详情页面
  {
    path: '/spaceReservation/reviewOrderDetails',
    name: 'spaceReservationReviewOrderDetails',
    component: () => import('@/sub-app/spaceReservation/pages/components/reviewOrderDetails.vue'),
    meta: {
      title: '订单详情',
      keepAlive: false,
    },
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  // 设置webview标题
  let title = to.meta?.title || '';
  const urlParams = getURLSearchParams();
  if (urlParams && urlParams.title) {
    title = decodeURIComponent(urlParams.title);
  }
  document.title = title;
  next();
});

export default router;
